export default __webpack_public_path__ + "static/founder_stories__what_has_it_been_like-e6b736ab8527992856c643eca9d4ec72.mp4";